<template>
  <div class="div-background">
    <div v-if="videoExists">
      <vue-plyr :options="options">
        <video
          controls
          crossorigin
          playsinline
          :src="video.mp4url"
          :poster="video.posterImage"
        >
          <track
            v-for="(subtitle, index) in formattedSubtitles"
            :key="index"
            :src="subtitle.uri"
            :label="subtitle.label"
            :srclang="subtitle.lang"
            kind="captions"
            :default="index === 0"
          />
        </video>
      </vue-plyr>
    </div>
    <div v-else>
      <img
        class="img-fluid"
        :src="videoPlaceholder"
        alt="Video non disponibile"
        title="Video non disponibile"
      />
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import languageISOCode from "@/data/iso_language_code.json";

export default {
  name: "VideoPlayer",
  data() {
    return {
      languageISOCode,
      video: {},
      videoPlaceholder: require("@/assets/images/placeholder/video-placeholder.jpg"),
      videoExists: true,
      options: {
        captions: { active: true, language: "auto", update: true },
      },
    };
  },
  computed: {
    formattedSubtitles() {
      if (!this.video.subtitles || !Array.isArray(this.video.subtitles)) {
        return [];
      }

      // Variabile per accumulare i risultati
      const subtitles = this.video.subtitles.map((subtitle) => {
        // Cerca nella tabella languageISOCode la descrizione della lingua
        const languageInfo = this.languageISOCode.find(
          (lang) => lang.isoCode === subtitle.lang
        );

        return {
          uri: subtitle.uri,
          lang: subtitle.lang,
          label: `${subtitle.lang} - ${languageInfo ? languageInfo.language : "Unknown"}`,
        };
      });

      // Restituisco i sottotitoli formattati
      console.log("** subtitles", subtitles);
      return subtitles;
    },
  },
  methods: {
    getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    },
  },
  async mounted() {
    const videoId = this.getQueryParam("id");
    if (!videoId) {
      this.videoExists = false;
      return;
    }
    try {
      const videoData = await api.getVideo(videoId);
      if (!videoData.data || !videoData.data.mp4url) {
        this.videoExists = false;
      } else {
        const videoObj = videoData.data;
        this.video.posterImage = videoObj.posterImage || this.videoPlaceholder;
        this.video.mp4url = videoObj.mp4url;
        this.video.subtitles = videoObj.subtitles || [];
        console.log("** video object", videoObj);
        await api.putVideoAddView(videoId); // Aggiorno le visualizzazioni
      }
    } catch {
      this.videoExists = false;
    }
  },
};
</script>

<style>
.plyr__captions {
  font-family: Arial, sans-serif !important;
  font-size: 28px !important;
  color: yellow !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.75);
  /* background-color: rgba(0, 0, 0, 0.5); */
  padding: 5px;
  border-radius: 5px;
}

.plyr__time {
  font-family: Arial, sans-serif !important;
}
</style>
